<template>
  <div>
      <el-breadcrumb separator="/" class="page-breadcrumb">
          <el-breadcrumb-item>协议录入</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="height: 30px;"></div>
      <el-card>
          <el-form :inline="true">
              <el-form-item>
                  <el-button type="primary" icon="el-icon-plus" @click="editType = 1,showEdit = true">添加协议</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="pageNo = 1,querySubmit()">查看</el-button>
              </el-form-item>
          </el-form>
          <el-table :data="agreements">
              <el-table-column label="协议类型">
                  <template slot-scope="scope">{{getAgreementTypeDesc(scope.row.agreementType)}}</template>
              </el-table-column>
              <el-table-column label="语言">
                  <template slot-scope="scope">{{getLanguageDesc(scope.row.language)}}</template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-button type="primary" icon="el-icon-edit" circle size="small" @click="editAgreement(scope.row)"></el-button>
                      <el-button type="danger" icon="el-icon-delete" circle size="small" @click="removeAgreement(scope.row.id)"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="25" :current-page="pageNo" @current-change="querySubmit"></el-pagination>
      </el-card>

      <el-dialog title="协议编辑" :visible.sync= "showEdit" @close="closeDialog">
          <el-form label-width="130px" :model="editInfo" ref="form">
              <el-form-item label="协议类型" prop="agreementType" :rules="[{ required: true, message: '协议类型不能为空'}]">
                  <el-select v-model="editInfo.agreementType" placeholder="请选择协议类型">
                      <el-option v-for="item in agreementTypes" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="语言" prop="languageCode" :rules="[{ required: true, message: '语言不能为空'}]">
                  <el-select v-model="editInfo.languageCode" placeholder="请选择语言">
                      <el-option v-for="item in languages" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="内容" prop="content" :rules="[{ required: true, message: '内容不能为空'}]">
                  <editor v-model="editInfo.content" style="height: 500px;"></editor>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="submitInfo">确定</el-button>
              </el-form-item>
          </el-form>
      </el-dialog>

  </div>
</template>

<script>
    import './store';
    import Editor from '../../components/editor';
    import {mapActions, mapState} from 'vuex';
    import api from './api';
    import moment from 'moment';

    export default {
        name: "agreement",
        components: {Editor},
        data() {
          return {
              showEdit : false,
              pageNo: 1,
              editInfo: {
                  agreementType : '',
                  languageCode : '',
                  content : '',
                  id : ''
              },
              agreementTypes: [{code : 'OTC_CUSTOMER_PROTOCOL',desc: 'otc用户账单服务协议'}],
              editType : 1,//编辑类型 1 为新增，2 为修改
          }
        },
        computed : {...mapState('agreement',['agreements','total','languages'])},
        methods : {
            ...mapActions('agreement',['getAllAgreements']),
            editAgreement(agreement){
                this.editType = 2;
               api.getAgreementById({id : agreement.id}).then(response => {
                   this.editInfo.agreementType = agreement.agreementType;
                   this.editInfo.languageCode = agreement.language;
                   this.editInfo.content = response.data;
                   this.editInfo.id = agreement.id;
                   this.showEdit = true;
                   console.log(response);
               })
            },

            removeAgreement(id) {
                api.deleteAgreement({id : id}).then( () => {
                    this.pageNo = 1;
                    this.querySubmit();
                    this.$message.success("删除成功");
                })
            },

            querySubmit(){
                this.getAllAgreements({
                    page : this.pageNo
                });
            },

            closeDialog() {
                this.$refs['form'].resetFields();
                this.showEdit = false;
            },

            submitInfo(){
                this.pageNo = 1;
                if (this.editType === 1) {
                    api.insertAgreement(this.editInfo).then( () => {
                        this.$message.success("新增成功");
                        this.showEdit = false;
                        this.querySubmit();
                    })
                }
                if (this.editType === 2) {
                    api.alterAgreement(this.editInfo).then( () => {
                        this.$message.success("修改成功");
                        this.showEdit = false;
                        this.querySubmit();
                    })
                }
            },

            getLanguageDesc(code) {
                for(let item in this.languages){
                    if (code === this.languages[item].code){
                        return this.languages[item].desc;
                    }
                }
            },

            getAgreementTypeDesc(code) {
                for(let item in this.agreementTypes){
                    if (code === this.agreementTypes[item].code) {
                        return this.agreementTypes[item].desc;
                    }
                }
            },

            dateFormat(row, column) {
                return moment(row.createTime).format("YYYY-MM-DD HH:mm:ss");
            },

        }
    }
</script>

<style scoped>

</style>